import * as React from 'react';

import type { ForgePagePanelCommonProps } from '@helpcenter/forge-ui-utils';
import {
	PORTAL_HEADER_MODULE,
	PORTAL_SUBHEADER_MODULE,
} from '@helpcenter/forge-ui-utils/src/constants';
import { di } from 'react-magnetic-di';
import { ForgeRunnerModule } from 'view/forge-ui/forge-runner';
import { ForgeRunnerContainer } from 'view/forge-ui/forge-runner/styled';

const ForgeHeaderModule: React.FC<ForgePagePanelCommonProps> = ({
	page,
	portalId,
	projectId,
	requestKey,
	requestTypeId,
	noWrapper,
	allowCustomPadding,
	skipHelpCenterWrapper,
}) => {
	di(ForgeRunnerModule);
	return (
		<ForgeRunnerContainer allowCustomPadding={allowCustomPadding}>
			<ForgeRunnerModule
				type={PORTAL_HEADER_MODULE}
				page={page}
				portalId={portalId}
				projectId={projectId}
				requestTypeId={requestTypeId}
				requestKey={requestKey}
				noWrapper={noWrapper}
				skipHelpCenterWrapper={skipHelpCenterWrapper}
			/>
			<ForgeRunnerModule
				type={PORTAL_SUBHEADER_MODULE}
				page={page}
				portalId={portalId}
				projectId={projectId}
				requestTypeId={requestTypeId}
				requestKey={requestKey}
				noWrapper={noWrapper}
				skipHelpCenterWrapper={skipHelpCenterWrapper}
			/>
		</ForgeRunnerContainer>
	);
};

export default ForgeHeaderModule;
